import { connect } from 'react-redux'
import React from 'react'
import styled from 'styled-components'
import {setActiveImage} from '../interview/actions'
import {ModalBackground} from "../common/components/Modal"
import {SVG_URL} from "../common/constants"

const Close = styled.img`
  position: absolute;
  top: -${28/18}rem; 
  right: 0;
  height: ${17/18}rem;
  width: ${17/18}rem;
  cursor: pointer;
`

const ModalBody = styled.div`
  max-width: ${600/18}rem;
  padding: ${10/18}rem;
  border-radius: 8px;
  margin: 1rem;
  position: relative;
  background: white;
`

const Image = styled.img`
  max-width: 100%;
  max-height: 66vh;
`

const Video = styled.video`
  width: 100%;
`

const PictureModal = ({image, closePictureModal}) => {
  if (image) {
    return <ModalBackground onClick={closePictureModal}>
       <ModalBody>
            <Close onClick={closePictureModal} alt="close" src={`${SVG_URL}x-icon.svg`}/>
            {
              (image.split('.').pop() === 'mp4') ?
                <Video controls autoPlay muted loop>
                  <source src={image} type="video/mp4"/>
                </Video>
                : <Image src={image} alt={image} />
            }
       </ModalBody>
    </ModalBackground>
  } else {
    return <span />
  }
}

const mapStateToProps = (state) => ({image: state.modals.activeImage})

const mapDispatchToProps = (dispatch) => ({
  closePictureModal() {
    dispatch(setActiveImage(''))
  }
})

const PictureModalContainer = connect(mapStateToProps, mapDispatchToProps)(PictureModal)

export { PictureModalContainer as default, PictureModal }



// WEBPACK FOOTER //
// ./assets/modals/PictureModal.js